import React from "react";
import classnames from "classnames";
import styles from "./Chip.module.scss";

export interface ChipProps {
    label: string;
    pressed: boolean;
    onChange: (next: boolean) => void;
    className?: string;
}

/**
 * Чип-переключатель фильтра. Выбранный отличается не только цветом: перед текстом стоит галочка.
 * Зона касания — не меньше 44×44 (видимая «таблетка» ниже, её окружает прозрачная область кнопки).
 */
export const Chip = ({ label, pressed, onChange, className }: ChipProps) => (
    <button
        type="button"
        className={classnames(styles.chip, { [styles.pressed]: pressed }, className)}
        aria-pressed={pressed}
        onClick={() => onChange(!pressed)}
    >
        <span className={styles.body}>
            {pressed && (
                <span className={styles.check} aria-hidden="true">
                    ✓
                </span>
            )}
            {label}
        </span>
    </button>
);
